module.exports = __webpack_public_path__ + "img/proctor-require-2.9a469181.png";